/* eslint-disable */
export default {
  _riffic_freebold: 'riffic_freebold',
}